export default __webpack_public_path__ + "static/media/CIS-gallery-2-NI-M300T-V-steam.4f2fd825.jpg";